module.exports = __webpack_public_path__ + "img/shopBanner.d4abaa1f.png";